<template>
    <div class="float-left mr-1">
        <span :class="`text-${cor}`">
            <i
                :class="`fa ${icone} fa-lg icon-button`"
                :title="titulo"
                @click.stop="exibirRateio()"
            ></i>
        </span>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'

export default {
    props: {
        cronogramaDesembolso: {
            type: Object,
            default: () => ({})
        },

        titulo: {
            type: String,
            default: () => 'Rateios'
        },

        icone: {
            type: String,
            default: () => 'fa-pie-chart'
        },

        cor: {
            type: String,
            default: () => 'primary'
        }
    },

    data() {
        return {}
    },

    methods: {
        exibirRateio() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterComprometimentoPorCronogramaDesembolso(
                this.$route.params.convenioId,
                this.cronogramaDesembolso.idCronogramaDesembolso)
                .then(response => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarComprometimento', response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter o comprometimento',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },
}
</script>
